import { AxiosPromise } from 'axios';
import { IGetFaq, IGetFaqs } from '../models/boardFaq.model';
import axios from 'axios';

const uri = '/mgmt/board/faq';

export const getFaqs = (): AxiosPromise<IGetFaqs> => {
  return axios.get(`${uri}`);
}

export const getFaq = (faqCode: number): AxiosPromise<IGetFaq> => {
  return axios.get(`${uri}/${faqCode}`);
}

export const createFaq = (data: FormData): AxiosPromise => {
  return axios.post(uri, data);
};

export const updateFaq = (faqCode: number, data: FormData): AxiosPromise => {
  return axios.put(`${uri}/${faqCode}`, data);
};

export const deleteFaq = (faqCode: number): AxiosPromise => {
  return axios.put(`${uri}/${faqCode}/remove`);
};
